import createUseNav from "@subly/s1/core/hooks/useNav";
import router from "routes";


export default createUseNav<typeof router>();